import { GenericService } from './generic.service';
import { BPMLocation } from '@/models';

export class OrganisationLocationService extends GenericService<BPMLocation> {
  constructor(organisationId: string) {
    super();
    this.endpoint = `v1/organisations/${organisationId}/locations`;
  }
}
